// get_product_categories
export const GET_PRODUCT_CATEGORIES = 'get_product_categories';
export const GET_PRODUCT_CATEGORIES_SUCCESSFUL =
  'get_product_categories_successfull';
export const GET_PRODUCT_CATEGORIES_FAILED = 'get_product_categories_failed';

// create_product_category
export const CREATE_PRODUCT_CATEGORY = 'create_product_category';
export const CREATE_PRODUCT_CATEGORY_SUCCESSFUL =
  'create_product_category_successfull';
export const CREATE_PRODUCT_CATEGORY_FAILED = 'create_product_category_failed';

// update_product_category
export const UPDATE_PRODUCT_CATEGORY = 'update_product_category';
export const UPDATE_PRODUCT_CATEGORY_SUCCESSFUL =
  'update_product_category_successfull';
export const UPDATE_PRODUCT_CATEGORY_FAILED = 'update_product_category_failed';

// delete_product_category
export const DELETE_PRODUCT_CATEGORY = 'delete_product_category';
export const DELETE_PRODUCT_CATEGORY_SUCCESSFUL =
  'delete_product_category_successfull';
export const DELETE_PRODUCT_CATEGORY_FAILED = 'delete_product_category_failed';

// exchange_product_cateory_order
export const EXCHANGE_PRODUCT_CATEORY_ORDER = 'exchange_product_cateory_order';
export const EXCHANGE_PRODUCT_CATEORY_ORDER_SUCCESSFUL =
  'exchange_product_cateory_order_successfull';
export const EXCHANGE_PRODUCT_CATEORY_ORDER_FAILED =
  'exchange_product_cateory_order_failed';
